import React from "react";
import { ReferenceCardProps } from "../../ReferenceCard";
import { RelatedCards } from "../../RelatedCards";

export interface RelatedCardsSerializerProps {
  cards?: ReferenceCardProps[];
  subtitle?: string;
  title?: string;
}

export const RelatedCardsSerializer = ({
  cards,
  subtitle,
  title
}: RelatedCardsSerializerProps) =>
  cards?.length ? <RelatedCards cards={cards} subtitle={subtitle} title={title} /> : null;
